// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__V3j_I","checked":"Checkbox_checked__2L37l","check-none":"Checkbox_check-none__3E2Qf"};